<template>
    <div>   
        <v-container grid-list-xl> 
            <!-- <v-btn color="success" @click="DELETE_ALL_SALES">DELETE_ALL_SALES</v-btn> -->
            <v-layout align-center="" justify-center="">

                <v-col sm="12" cols="12">
                    <br> 
                    <v-card > 
                        <mbs-page-tab 
                            :items="MY_LINKS"/> 
                             
                        <mbs-item-manager
                            v-model="input_table"
                            :row_click="true"
                            :show_select="false"
                            :row_click_action="false" 
                            :table_tabs="tableTabs"

                            :add_vertical_lines="true"
                            :top_label="false"
                            :filter_date="true"
                            :filter_dayshifts="false"
                            :filter_date_only_display="true"
                            :filter_date_value="'local_created_at'"
                            :filter_default_days="'1'"
                            :filters="FILTERS"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="FIELD_ITEMS"
                            :header_items="HEADER_ITEMS" 
                            :data_items="CalculatedItems"   
                            :select_items="DataSource"   
                            :is_joined="true"  
                            :path_item="SALES_PATH"   
                            :total_item_values="TOTAL_ITEM_VALUES"   

                            :table_actions="TableActions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                            @apply="APPLY_DAYSHIFTS"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
        <div>
            <div v-if="dialog_doc_show"> 
                <mbs-dialog-doc-show
                    v-model="dialog_doc_show" 
                    :title="input_show_doc.title"
                    :data="input_show_doc.data"
                    :data_key="input_show_doc.data_key"
                    :document_type="input_show_doc.document_type"
                    :height="input_show_doc.height"
                    :top_header="input_show_doc.top_header"
                    :bottom_header="input_show_doc.bottom_header"
                />  
            </div>
            <mbs-receipt-finder
                v-model="input_receipts"
                :dialog_show="receipt_finder?.dialog_show"
                :dialog_title="receipt_finder?.dialog_title"
                :receipt_key="receipt_finder?.receipt_key" 
            />
            
        </div>
    </div> 
</template>

<script>
    import DATA from "../../../../../plugins/DATA"
    let PAGE_NAME = DATA.ITEMS.RETURNED_SALES.values+"_transactions"    
    import {mapState,mapGetters } from "vuex"
    import { mdiReceiptTextArrowRight } from '@mdi/js';
    import { mdiTextBoxSearch } from '@mdi/js';
    import moment from "moment";
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.RETURNED_SALES.names,
                NAME_ITEM:DATA.ITEMS.RETURNED_SALES.name,
                VALUE_ITEMS:DATA.ITEMS.SALE_ORDERS.values,
                VALUE_ITEM:DATA.ITEMS.SALE_ORDERS.value,  

                FIELD_ITEMS:[
                    {type:"number",name:"code",value:"code",label:"Code",required:true,sm:12,md:12}, 
                    {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:12},   
                ],     
                table_actions:[
                    // {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},   
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ],
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Total Items',value:'total_quantity'},  
                    {name:'Total Refund',value:'total_refund_amount',show_value:'total_refund_amount_',money:true},  
                ], 
                filteredDate:null,
                dialog_doc_show:false,
                currentTableTab:null,
                input_table:null, 
                input_show_doc:{
                    // title:"INVOICE..",
                    top_header:true
                },
                tableTabs:[
                    // {name:"Returns",show_if:null},
                    {name:"Returned Items",show_if:null},
                    {name:"Aggregated Returns",show_if:null},
                    {name:"Return Transactions",show_if:null},
                    // {name:"Over Paid Invoices",show_if:item=>item.balance<0},
                ],
                receipt_finder:{
                    dialog_show:false,
                    dialog_title:'',
                },
                input_receipts:null,
                mdiTextBoxSearch: mdiTextBoxSearch, 
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try { 
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                })
                this.FEEDBACKS(1000) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        computed: { 
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("sales",3,true) 
                return thisLinks
            }, 
            SALES_PATH(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.sale_orders,true) 
                return path
            }, 
            moment(){  
                return this.MBS.date.moment
            }, 
            /////////
             ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SelectedCompany: state=> state.items['SELECTED_COMPANY'],

            }),
            ...mapState({
                SalesReturns: state=> state.items[(DATA.ITEMS.RETURNED_SALES.values).toUpperCase()],
                JoinedSalesReturns: state=> state.join[(DATA.ITEMS.RETURNED_SALES.values).toUpperCase()], 
                
                Customers: state=> state.items[(DATA.ITEMS.CUSTOMERS.values).toUpperCase()],
                PaymentMethods: state=> state.items[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                JoinedPaymentMethods: state=> state.join[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                DefaultPaymentMethod: state=> state.app[(DATA.ITEMS.DEFAULT_PAYMENT_METHODS.values).toUpperCase()],
                Departments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                JoinedDepartments: state=> state.join[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                Cashups: state=> state.items[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
                JoinedCashups: state=> state.join[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
                DayShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
                JoinedDayShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
            }), 
            PaymentMethodsData(){ 
                let DefaultPaymentMethod = this.DefaultPaymentMethod 
                let PaymentMethods = this.PaymentMethods
                let JoinedPaymentMethods = this.JoinedPaymentMethods
                let items = JoinedPaymentMethods?JoinedPaymentMethods:PaymentMethods 
                if(!items){return DefaultPaymentMethod}
                let list = [...DefaultPaymentMethod,...items]  
                return list
            },  
            DepartmentsData(){ 
                let Departments = this.Departments
                let JoinedDepartments = this.JoinedDepartments
                let items = JoinedDepartments?JoinedDepartments:Departments 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true)) 
                return list
            },  
            SalesReturnsData(){ 
                let SalesReturns = this.SalesReturns
                // let res = await this.$store.dispatch("join",{data:SalesReturns,name:"ALL_"+DATA.ITEMS.RETURNED_SALES.values})
                // console.log(res,'res..............');
                // let JoinedSalesReturns = res?.data?.joined
                let JoinedSalesReturns = this.JoinedSalesReturns
                console.log(JoinedSalesReturns,'JoinedSalesReturns..............');
                
                let items = JoinedSalesReturns?JoinedSalesReturns:SalesReturns
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  

                console.log(list,'l+++++++++++++++');
                console.log(SalesReturns,'SalesReturns+++++++++++++++');
                
                return list
            }, 
            OutletsData(){ 
                let Outlets = this.Outlets
                let JoinedOutlets = this.JoinedOutlets
                let items = JoinedOutlets?JoinedOutlets:Outlets 
                return items
            }, 
            DayShiftsData(){ 
                let DayShifts = this.DayShifts
                let JoinedDayShifts = this.JoinedDayShifts
                let items = JoinedDayShifts?JoinedDayShifts:DayShifts  
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))   
                return list 
            },  
            CashupsData(){ 
                let Cashups = this.Cashups
                let JoinedCashups = this.JoinedCashups
                let items = JoinedCashups?JoinedCashups:Cashups 
                return items
            }, 
            DayShiftsCashups(){
                let days = this.DayShiftsData
                if(!days){return null}
                let cashups = []
                days.forEach(element => {
                    if (element.joined_cashups) {
                        cashups = [...cashups,...element.joined_cashups]
                    }
                }); 
                if(!cashups){return null} 
                let list = [...cashups]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))    
                return list 
            },
            Users(){
                let items  =this.$store.getters.getCompanyUsers
                let list = items?[...items]:null
                if(!list){return null}
                list.sort(this.MBS.actions.dynamicSort('created_at',false))
                return list
            }, 
            JoinedUsers(){
                let users = this.Users
                let join = this.MBS.actions.JOIN_USERS(users)
                return join
            }, 
            DataSource(){ 
                let Customers = this.Customers
                let PaymentMethodsData = this.PaymentMethodsData
                let Departments = this.DepartmentsData
                let Outlets = this.OutletsData
                let DayShifts = this.DayShiftsData
                let Cashups = this.DayShiftsCashups
                let SalesReturns = this.SalesReturnsData
                let Tellers = this.JoinedUsers 
                return { 
                    Customers:Customers,
                    PaymentMethods:PaymentMethodsData,
                    Departments:Departments,
                    Outlets:Outlets,
                    DayShifts:DayShifts,
                    Cashups:Cashups,
                    SalesReturns:SalesReturns,
                    Tellers:Tellers,
                }
            },

            TableActions(){
                let dr = this.ItemsDownloadRequest 
                let dr_on = dr?.on
                let selected_items = this.selected_items
                let input_table = this.input_table
                let show_select = input_table?input_table.show_select:false
                let main_action = [
                    {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false, indicator_r:dr_on,  text:"Refresh"},   
                    {type:"btn",icon:"mdi-receipt",color:"secondary", text:"Invoices / Receipts", min_width:"",action:"receive",
                    actions:[
                        {icon:mdiTextBoxSearch,action:"find_receipt",text:"Find Invoice / Receipt"},
                        {icon:"mdi-cart-off",action:"sales_return",text:"Return Sales"}, 
                    ]} , 
                   {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ] 
                return  main_action
            },
            FILTERS(){ 
                return [ 
                    // {
                    //     type:"autocomplete",value:"department_code",prepend_inner_icon:'mdi-format-list-group',clearable:true,filled:false,multiple:true
                    //     ,chips:true,deletable_chips:true,label:"Department",
                    //     select:{
                    //         name:'Departments',
                    //         value:'code',
                    //         text:'name'
                    //     }, 
                    //     required:false,sm:12,md:12,step_name:"Name"
                    // },

                    {
                        type:"autocomplete",value:"payment_method_name",prepend_inner_icon:'mdi-account-cash',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Payment",
                        select:{
                            name:'PaymentMethods',
                            value:'name',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"receipt_number",barcode:true,prepend_inner_icon:'mdi-barcode',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Receipt Number",
                        select:{
                            name:'SalesReturns',
                            value:'receipt_number',
                            text:'receipt_number'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"created_uid",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Teller Name",
                        select:{
                            name:'Tellers',
                            value:'uid',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"customer_key",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Customer",
                        select:{
                            name:'Customers',
                            value:'key',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"cashup_key",barcode:true,prepend_inner_icon:'mdi-account-cash-outline',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Cashup",
                        select:{
                            name:'Cashups',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-account-cash-outline',
                                tile:true
                            },
                            item_title:['till_name'],
                            item_subtitle:['teller_name','key','local_created_at_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"day_shift_key",barcode:true,prepend_inner_icon:'mdi-network-pos',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Day Shift",
                        select:{
                            name:'DayShifts',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-network-pos',
                                tile:true
                            },
                            item_title:['outlet_name'],
                            item_subtitle:['teller_name','operating_date_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"outlet_code",barcode:true,prepend_inner_icon:'mdi-sitemap',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Outlet",
                        select:{
                            name:'Outlets',
                            value:'code',
                            text:'name'
                        }, 
                        required:false,sm:12,md:12,step_name:"Name"
                    },    
                ]
            }, 
            HEADER_PER_TRANSACTION_ITEMS(){
                
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false}, 
                    {id:0,name:"date",value:'local_created_at_',show:true},           
                    {id:0,same_length:6,name:"Barcode",value:'code',show:false},   
                    {id:0,same_length:6,name:"Return code",value:'return_code',show:false},   
                    {id:0,name:"Sales No.",value:"sale_order_key",show:false},     
                    {id:0,name:"Item",value:"name",show:true},  

                    {id:0,name:"Department",value:"item_department_name",show:false}, 
                    {id:0,name:"Department Code",value:"item_department_code",show:false},
                    {id:0,name:"Category",value:"category_name",show:true}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 

                    {id:0,money:true,name:"Cost Price",value:'sold_cost_price',align:'right',show:false},   
                    {id:0,money:true,name:"Sold Price",value:'sold_price',align:'right',show:false},   
                    {id:0,money:true,name:"Discount",value:'sold_discount',align:'right',show:true},   
                    {id:0,number:true,name:"Sold QTY",value:'sold_quantity',align:'right',show:true},   
                    {id:0,number:true,name:"Return QTY",value:'return_quantity',align:'right',show:true},   
                    {id:0,money:true,name:"Refund",value:'total_return_price',align:'right',show:true},   
                    {id:0,name:"Created",value:'created_at_',show:false},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Sales Report",action:"view_sales_report",icon:"mdi-eye"}, 
                        {name:"View Return Report",action:"view_return_report",icon:"mdi-eye"}, 
                        // {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            }, 
            HEADER_AGGREGATED_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Barcode",value:'code',show:true},           
                    {id:0,name:"item",value:"name",show:true},     

                    {id:0,name:"Department",value:"item_department_name",show:false}, 
                    {id:0,name:"Department Code",value:"item_department_code",show:false},
                    {id:0,name:"Category",value:"category_name",show:true}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 

                    {id:0,name:"Transactions",value:"number_of_transactions",align:'center',show:true},     
                    {id:0,name:"Discount",value:'return_discount',align:'right',show:false},   
                    {id:0,name:"Sold QTY",value:'sold_quantity',align:'center',show:true},   
                    {id:0,name:"Return QTY",value:'return_quantity',align:'center',show:true},    
                    {id:0,money:true,name:"Refund",value:'total_return_price',align:'right',show:true},     
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"..",action:"view",icon:"mdi-eyeee"}, 
                        // {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            },
            HEADER_RETURN_TRANSACTIONS(){ 
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false}, 
                    {id:0,name:"date",value:'local_created_at_',show:true},           
                    {id:0,same_length:6,name:"Return code",value:'code',show:true},   
                    {id:0,name:"Sales No.",value:"sale_order_key",show:true},      
                    
                    {id:0,name:"Outlet",value:"outlet_name",show:true}, 
                    {id:0,name:"Outlet Code",value:"outlet_code",show:false}, 
                    
                    {id:0,money:false,name:"Payment",value:'payment_method_name',align:'left',show:true},      
                    {id:0,number:false,name:"Return By",value:'return_user_name',align:'left',show:true},   
                    {id:0,number:false,name:"Customer",value:'customer_name',align:'left',show:true},   
                    {id:0,name:"Items",value:"items_size",show:true},  
                    {id:0,money:true,name:"Refund",value:'total_refund_amount',align:'right',show:true},   
                    {id:0,name:"Created",value:'created_at_',show:false},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Sales Report",action:"view_sales_report",icon:"mdi-eye"}, 
                        {name:"View Return Report",action:"view_return_report",icon:"mdi-eye"}, 
                        // {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            }, 
            HEADER_ITEMS(){
                let tap = this.currentTableTab
                if (tap==0) {
                    return this.HEADER_PER_TRANSACTION_ITEMS
                }else if(tap==1){
                    return this.HEADER_AGGREGATED_ITEMS
                }else{
                    return this.HEADER_RETURN_TRANSACTIONS
                }
            }, 
            AggregatedItems(){
                let SaleOrders = this.SalesReturnsData
                let moment = this.moment

                 
                let filteredDate = this.filteredDate
                let difference = filteredDate?filteredDate.difference:null
                let to_date = filteredDate?filteredDate.to_date:null
                let from_date = filteredDate?filteredDate.from_date:null 
                if(!SaleOrders){return null}
                let items = [] 
                
                SaleOrders?.forEach(order => {
                    let date = moment(order.local_created_at).format("yyyy-MM-D")
                    let momentDate = moment(date) 
                    let isBetween = momentDate.isBetween(from_date,to_date,'','[]')  
                    // isBetween = true
                    if (isBetween) {
                        let unjoined_items = order.items
                        let joined_items = order.joined_items
                        let sold_items = joined_items?joined_items:unjoined_items 
                        let total_discount = this.toNumber(order.total_discount)
                        let item_size = this.MBS.actions.SIZE(sold_items)
                        let average_discount = total_discount/item_size
                        if (sold_items) {
                            sold_items.forEach(item => { 
                                let index = items.findIndex(it=>it.item_key  == item.item_key) 
                                const item_detail = this.$store.getters.getItemByKey(item.item_key)
                                const sold_quantity = this.toNumber(item.sold_quantity)
                                const return_quantity = this.toNumber(item.return_quantity)
                                const sold_cost_price = this.toNumber(item.sold_cost_price)*sold_quantity
                                const return_cost_price = this.toNumber(item.sold_cost_price)*return_quantity
                                const sold_discount = (this.toNumber(item.discount)*return_quantity)+average_discount
                                const return_discount = (this.toNumber(item.discount)*return_quantity)+average_discount
                                const sold_price = this.toNumber(item.sold_price)
                                const total_sold_price = (sold_price*return_quantity)-sold_discount 
                                const total_return_price = (sold_price*return_quantity)-sold_discount 

                                console.log(item_detail,'item_detail++++++++++++++++++++++++++++');
                                
                                if (index == -1) { 
                                     
                                    items.push({ 
                                        ...item_detail,
                                        ...item, 
                                        day_shift:order.day_shift,
                                        day_shift_key:order.day_shift_key,
                                        cashup:order.cashup,
                                        cashup_key:order.cashup_key,
                                        outlet:order.outlet,
                                        outlet_code:order.outlet_code,

                                        sold_quantity:sold_quantity,
                                        return_quantity:return_quantity,
                                        sold_cost_price:sold_cost_price,
                                        return_cost_price:return_cost_price,
                                        sold_discount:sold_discount,
                                        return_discount:return_discount,
                                        sold_price:sold_price,
                                        total_sold_price:total_sold_price,
                                        total_return_price:total_return_price,
                                        number_of_transactions:1,
                                         
                                    })
                                } else {
                                    items[index].sold_quantity = items[index].sold_quantity+sold_quantity
                                    items[index].return_quantity = items[index].return_quantity+return_quantity
                                    items[index].sold_cost_price = items[index].sold_cost_price+sold_cost_price
                                    items[index].return_cost_price = items[index].return_cost_price+return_cost_price
                                    items[index].sold_discount = items[index].sold_discount+sold_discount
                                    items[index].return_discount = items[index].return_discount+return_discount
                                    items[index].sold_price = items[index].sold_price+sold_price
                                    items[index].total_sold_price = items[index].total_sold_price+total_sold_price
                                    items[index].total_return_price = items[index].total_return_price+total_return_price
                                    items[index].number_of_transactions = items[index].number_of_transactions+1
                                     
                                }    
                            });
                            
                        }
                    }     
                });  
               
               
                return items
            },
            PerTransactionItems(){ 
                let returnOrders = this.SalesReturnsData
                let moment = this.moment
                let filteredDate = this.filteredDate
                let difference = filteredDate?filteredDate.difference:null
                let to_date = filteredDate?filteredDate.to_date:null
                let from_date = filteredDate?filteredDate.from_date:null
                if(!returnOrders){return null}
                let items = []
                returnOrders.forEach(order => {  
                    let date = moment(order.local_created_at).format("yyyy-MM-D")
                    let momentDate = moment(date) 
                    let isBetween = momentDate.isBetween(from_date,to_date,'','[]')  
                    // isBetween = true
                    if (isBetween) { 
                        const unjoined_items = order.items
                        const joined_items = order.joined_items
                        const returned_items = joined_items?joined_items:unjoined_items 
                        const total_discount = this.toNumber(order.total_discount)
                        const item_size = this.MBS.actions.SIZE(returned_items)
                        const average_discount = total_discount/item_size
                        if (returned_items) {
                            returned_items.forEach(item => { 
                                const item_detail = this.$store.getters.getItemByKey(item.item_key)
                                const sold_quantity = this.toNumber(item.sold_quantity)
                                const return_quantity = this.toNumber(item.return_quantity)
                                const sold_cost_price = this.toNumber(item.sold_cost_price)*sold_quantity
                                const return_cost_price = this.toNumber(item.sold_cost_price)*return_quantity
                                const sold_discount = (this.toNumber(item.discount)*return_quantity)+average_discount
                                const return_discount = (this.toNumber(item.discount)*return_quantity)+average_discount
                                const sold_price = this.toNumber(item.sold_price)
                                const total_sold_price = (sold_price*return_quantity)-sold_discount 
                                const total_return_price = (sold_price*return_quantity)-sold_discount 

                                 
                                items.push({
                                    ...item_detail,
                                    ...item, 
                                    return_code:order.code,
                                    day_shift:order.day_shift,
                                    day_shift_key:order.day_shift_key,
                                    cashup:order.cashup,
                                    cashup_key:order.cashup_key,
                                    outlet:order.outlet,
                                    outlet_code:order.outlet_code,
                                    outlet_code:order.outlet_code,

                                    // sold_quantity:sold_quantity,
                                    // return_quantity:return_quantity,
                                    sold_cost_price:sold_cost_price,
                                    return_cost_price:return_cost_price,
                                    sold_discount:sold_discount,
                                    return_discount:return_discount,
                                    sold_price:sold_price,
                                    total_sold_price:total_sold_price,
                                    total_return_price:total_return_price,
                                    
                                    return_quantity_:this.MBS.actions.money( return_quantity),
                                    sold_cost_price_:this.MBS.actions.money( sold_cost_price),
                                    sold_discount_:this.MBS.actions.money( sold_discount),
                                    sold_price_:this.MBS.actions.money( sold_price),
                                    total_sold_price_:this.MBS.actions.money( total_sold_price),
                                    
                                    transaction_key:order.key,

                                    local_created_at:order.local_created_at,
                                    local_created_at_:order.local_created_at_,
                                    local_created_at_date:order.local_created_at_date,
                                    local_created_at_time:order.local_created_at_time,
                                })
                                     
                            });
                            
                        }
                    }     
                });   
                return items
            },
            CalculatedItems(){
                let tap = this.currentTableTab
                let PerTransactionItems = this.PerTransactionItems
                let AggregatedItems = this.AggregatedItems
                let SalesReturnsData = this.SalesReturnsData
                if (tap==0) {
                    return this.PerTransactionItems
                }else if(tap == 1){
                    return this.AggregatedItems
                }else{
                    return this.SalesReturnsData
                }
            } 
               
        },
        methods: { 
            async DELETE_ALL_SALES(){
                try {
                    let items = this.SalesReturnsData
                    let size = this.MBS.actions.SIZE(items)
                    let progress = 0

                      
                    if(!items){
                    } 

                    // return
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Deleting ("+size+"/"+progress+") ..."
                    })

                    // let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.,true)
                    // let path = "/MPOS/COMPANY_DATA/all-supplieers/ACCOUNTS/DAYS_SHIFT_SALES"
                    // let path = "/MPOS/COMPANY_DATA/mangochi-sun-supermarket/ACCOUNTS/DAYS_SHIFT_SALES/"
                    let path = "/MPOS/COMPANY_DATA/vybe-cafe-&-bistro/ACCOUNTS/DAYS_SHIFT_SALES/"

                    
                    let delete_items = []
                    for (const item of items) {
                        // let res = await this.$store.dispatch('fi_delete',{
                        //     action:DATA.ITEMS.ITEMS.values+"__", 
                        //     path:path+item.day_shift_key+'/'+item.key, 
                        // }) 
                        progress = progress+1
                        this.MBS.actions.progressDialog({ 
                            show:true,
                            text:"Deleting ("+size+"/"+progress+") ..."
                        })
                        delete_items.push({
                            path:path+item.day_shift_key+'/'+item.key,
                            key:item.key,
                            day_shift_key:item.day_shift_key,
                        })
                        console.log(path+item.day_shift_key+'/'+item.key,'path:, ....');
                        
                    }
                    console.log(delete_items,'delete_items------i--');

                    this.$store.dispatch('fi_delete',{
                        action:"day_shifts",
                        data:delete_items,
                        multiple:true
                    }).then(res=>{
                        console.log(res,'res.......i....');
                    }).catch(error=>{
                        console.log(error,'error-----------i..');
                    })
                    this.MBS.actions.progressDialog()
                } catch (error) {
                    console.log(error,'ee,,,,,,,,');
                }

            },
            TABLE_ACTION(action,item){
                try { 
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "received_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock",true))
                    }else if (action == "return_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/return-stock",true))
                    }else if (action == "transfer_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/transfer-stock",true))
                    }else if (action == "sales_return") {
                        let link = "/stock/stock-control/sales-return"
                        const path = this.MBS.actions.COMPANY_LINK(link,true) 
                        this.MBS.actions.go(path)
                    }else if (action == "find_receipt") {
                        this.MBS.events.$emit('ON_FIND_RECEIPTS',{show:true})
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try { 
                    let link = "/stock/stock-control/"+(item?item.key:null)
                    const path = this.MBS.actions.COMPANY_LINK(link,true)  

                    let doc_title = null
                    let doc_type = null
                    if (item?.account_type == "on_account") {
                            doc_title = "INVOICE"
                            doc_type = "invoice"
                    } else {
                        doc_title = "SALES RETURN"
                        doc_type = "return" 
                    }
                    console.log(item,'item.........');
                    
                    if (action == "view_order_page") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-receipt/"+receipt_key) 
                    }else if (action == "view_order") {  
                        if (doc_title) { 
                            this.SHOW_DIALOG_DOCUMENT({
                                data:item,
                                doc_title:doc_title,
                                doc_type:doc_type,
                            })
                        }
                    }else if (action == "on_row_clicked") { 
                        if (doc_title) { 
                            this.SHOW_DIALOG_DOCUMENT({
                                data:item,
                                doc_title:doc_title,
                                doc_type:doc_type,
                            })
                        }
                    } if (action == "log") {
                        console.log(item,'.item............');
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            RELOAD_ITEMS(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.DAYS_SHIFTS_SALES.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            APPLY_DAYSHIFTS(data){
                try {
                    console.log(data,'APPLY_DAYSHIFTS........');
                    const dayshifts_keys = data?.dayshifts_keys
                    const selected_dayshifts_keys = data?.selected_dayshifts_keys
                    const search_keys = this.MBS.actions.SIZE(selected_dayshifts_keys)?
                        selected_dayshifts_keys:dayshifts_keys
                     
                    console.log(search_keys,'search_keys.....');
                    
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"getting..."
                    })
                    this.$store.dispatch('http_get_item',{
                        name:DATA.ITEMS.DAYS_SHIFTS_SALES.values,
                        company_key:company_key,
                        path:"getDayShiftsSales", 
                        data: {
                            company_key:company_key,
                            day_shifts_keys:search_keys
                        }
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        console.log(res,'res..............');
                        
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            SHOW_DIALOG_DOCUMENT(payload){
                try {
                    let data = {}
                    let doc_type = payload?.doc_type
                    let doc_title = payload?.doc_title
                    if(payload?.data){
                        data = payload?.data
                    }
                    if(payload?.key){
                        data.key = payload?.key
                    }
                    if(!this.input_show_doc){
                        this.input_show_doc = {}
                    } 
                    if(data=={}){return null}
                    if (doc_type) {
                        console.log(doc_type,'doc_type/.................');
                    }

                    this.input_show_doc.data = {...data,merge_doc_type:"receipt"}
                    this.input_show_doc.data_key = data.key
                    this.input_show_doc.title = doc_title
                    this.input_show_doc.document_type = doc_type?doc_type:"invoice"
                    this.dialog_doc_show = true  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SHOW_DIALOG_DOCUMENT',
                        page:PAGE_NAME, 
                    }) 
                }

            },
            SHOW_DOCUMENT(payload){  
                try {   
                    const  this_document = (payload?.join_sale_order)?(payload?.join_sale_order):(payload?.sale_order)
                    if(!this_document){return } 
                    this.input_show_doc = {}
                    // this.input_show_doc.document_type = 'receipt'
                    this.input_show_doc.data_key = this_document?.key
                    this.input_show_doc.data = {...this_document,merge_doc_type:"receipt"}
                    this.dialog_doc_show = true 
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SHOW_DOCUMENT',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS()
                            } else {
                                
                            }
                        }   
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            
                             
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            PAGE_PERMISSION(){
                try {
                    let us
                    if (!us) {
                        this.MBS.actions.go("/")
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'PAGE_PERMISSION',
                        page:PAGE_NAME, 
                    })
                }
            },
    
        },
        watch: { 
            us(v){
                this.PAGE_PERMISSION()
            },
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            },
            input_table(value){  
                if (value) {
                    this.filteredDate = value.filter_date
                    this.currentTableTab = value.current_table_tab
                } 
            },
            input_receipts(value){     
                this.SHOW_DOCUMENT(value)
            },
        },
    }
</script>
 
